<!--*
 * Modal to show how to use the application
 *
 * @author   pablo.barco
 * @date     2024-22-01
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <AppModal :title="$t('burgerMenu.profile')" :show="show"
            show-close @on-close-click="closeHandler" @on-click-outside="closeHandler">
    <ProfileDetails modal-view />
  </AppModal>
</template>

<script>
import AppModal from "@/components/SharedComponents/AppModal.vue";
import ProfileDetails from "@/components/hamburgerMenu/components/ProfileDetails.vue";

export default {
  'name': 'ProfileModal',
  components: { ProfileDetails, AppModal },
  'props': {
    'show': {
      'type': Boolean,
      'default': false
    }
  },
  'methods': {
    closeHandler() {
      this.$emit('dismiss');
    }
  }
}
</script>

<style scoped>

</style>
